import React from 'react';
import './WorldRecords.css';

const worldRecords = {
  '1.5': {
    men: {
      time: '3:26.00',
      pace: '2:17.33',
      name: 'Hicham El Guerrouj',
      country: 'Morocco',
      year: '1998'
    },
    women: {
      time: '3:50.07',
      pace: '2:33.38',
      name: 'Genzebe Dibaba',
      country: 'Ethiopia',
      year: '2014'
    }
  },
  '3': {
    men: {
      time: '7:20.67',
      pace: '2:26.89',
      name: 'Daniel Komen',
      country: 'Kenya',
      year: '1996'
    },
    women: {
      time: '8:06.11',
      pace: '2:42.04',
      name: 'Wang Junxia',
      country: 'China',
      year: '1993'
    }
  },
  '5': {
    men: {
      time: '12:35.36',
      pace: '2:31.07',
      name: 'Joshua Cheptegei',
      country: 'Uganda',
      year: '2020'
    },
    women: {
      time: '14:06.62',
      pace: '2:49.32',
      name: 'Letesenbet Gidey',
      country: 'Ethiopia',
      year: '2020'
    }
  },
  '10': {
    men: {
      time: '26:11.00',
      pace: '2:37.06',
      name: 'Rhonex Kipruto',
      country: 'Kenya',
      year: '2020'
    },
    women: {
      time: '29:01.03',
      pace: '2:54.10',
      name: 'Yalemzerf Yehualaw',
      country: 'Ethiopia',
      year: '2022'
    }
  },
  '15': {
    men: {
      time: '41:13',
      pace: '2:44.87',
      name: 'Jacob Kiplimo',
      country: 'Uganda',
      year: '2021'
    },
    women: {
      time: '44:20',
      pace: '2:57.33',
      name: 'Letesenbet Gidey',
      country: 'Ethiopia',
      year: '2021'
    }
  },
  '21.0975': {
    men: {
      time: '57:31',
      pace: '2:43.55',
      name: 'Jacob Kiplimo',
      country: 'Uganda',
      year: '2021'
    },
    women: {
      time: '1:02:52',
      pace: '2:58.80',
      name: 'Letesenbet Gidey',
      country: 'Ethiopia',
      year: '2021'
    }
  },
  '42.195': {
    men: {
      time: '2:00:35',
      pace: '2:51.41',
      name: 'Kelvin Kiptum',
      country: 'Kenya',
      year: '2023'
    },
    women: {
      time: '2:09:56',
      pace: '3:05.00',
      name: 'Ruth Chepngetich',
      country: 'Kenya',
      year: '2024'
    }
  },
  '4.828': { // 3 miles
    men: {
      time: '12:49.08',
      pace: '2:39.36',
      name: 'Daniel Komen',
      country: 'Kenya',
      year: '1996'
    },
    women: {
      time: '14:23.75',
      pace: '2:58.90',
      name: 'Genzebe Dibaba',
      country: 'Ethiopia',
      year: '2014'
    }
  },
  '8.047': { // 5 miles
    men: {
      time: '21:29',
      pace: '2:40.30',
      name: 'Sifan Hassan',
      country: 'Netherlands',
      year: '2019'
    },
    women: {
      time: '24:32',
      pace: '3:02.90',
      name: 'Sifan Hassan',
      country: 'Netherlands',
      year: '2019'
    }
  },
  '16.093': { // 10 miles
    men: {
      time: '44:24',
      pace: '2:45.30',
      name: 'Rhonex Kipruto',
      country: 'Kenya',
      year: '2020'
    },
    women: {
      time: '50:05',
      pace: '3:06.80',
      name: 'Joyciline Jepkosgei',
      country: 'Kenya',
      year: '2017'
    }
  }
};

const convertPaceToMiles = (paceStr) => {
  // Convert pace from min/km to min/mile
  const [minutes, seconds] = paceStr.split(':').map(Number);
  const totalSeconds = minutes * 60 + seconds;
  const milesPaceSeconds = totalSeconds * 1.60934; // Convert km to miles
  const milesMinutes = Math.floor(milesPaceSeconds / 60);
  const milesSeconds = Math.round(milesPaceSeconds % 60);
  return `${milesMinutes}:${milesSeconds.toString().padStart(2, '0')}`;
};

const roundPaceToNearestSecond = (paceStr) => {
  const [minutes, seconds] = paceStr.split(':').map(Number);
  const totalSeconds = minutes * 60 + seconds;
  const roundedSeconds = Math.round(totalSeconds);
  const roundedMinutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;
  return `${roundedMinutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const WorldRecords = ({ selectedDistance, useKilometers }) => {
  const records = worldRecords[selectedDistance];

  if (!records) return null;

  const formatPace = (paceStr) => {
    const roundedPace = roundPaceToNearestSecond(paceStr);
    return useKilometers ? roundedPace : convertPaceToMiles(roundedPace);
  };

  return (
    <div className="world-records">
      <h3>World Records</h3>
      <table>
        <thead>
          <tr>
            <th>Category</th>
            <th>Time</th>
            <th>Pace</th>
            <th>Holder</th>
            <th>Country</th>
            <th>Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Men</td>
            <td>{records.men.time}</td>
            <td>{formatPace(records.men.pace)} {useKilometers ? 'min/km' : 'min/mile'}</td>
            <td>{records.men.name}</td>
            <td>{records.men.country}</td>
            <td>{records.men.year}</td>
          </tr>
          <tr>
            <td>Women</td>
            <td>{records.women.time}</td>
            <td>{formatPace(records.women.pace)} {useKilometers ? 'min/km' : 'min/mile'}</td>
            <td>{records.women.name}</td>
            <td>{records.women.country}</td>
            <td>{records.women.year}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default WorldRecords; 